import * as React from "react";
import { IconButton, styled } from "@mui/material";
import { useClinicNavigator } from "../util/useClinicNavigator";
import { ClinicRoute } from "../../../clinic/ClinicRoutes";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { AgentTooltip } from "fe-common/ui/AgentTooltip";
import { useClinicState } from "../../../clinic/clinicStateContext";
import { FileCopyOutlined } from "@mui/icons-material";
//region [[ Styles ]]

const Tooltip = styled(AgentTooltip)({});
//endregion [[ Styles ]]

//region [[ Props ]]

export interface AddClinicButtonProps {}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const AddClinicButton = ({ ...props }: AddClinicButtonProps) => {
  const { goToRoute } = useClinicNavigator();
  const [
    {
      clinicData: { id: clinicId },
    },
  ] = useClinicState();

  const handleDuplicateButtonClicked = () => {
    goToRoute(ClinicRoute.Duplicate, { pathAdditions: clinicId });
  };

  const handleButtonClicked = () => {
    goToRoute(ClinicRoute.New);
  };
  return (
    <>
      <Tooltip key={"add-clinic"} title={"Create another clinic"}>
        <IconButton onClick={handleButtonClicked}>
          <AddCircleIcon />
        </IconButton>
      </Tooltip>
      <Tooltip key={"duplicate-clinic"} title={"Duplicate clinic"}>
        <IconButton onClick={handleDuplicateButtonClicked}>
          <FileCopyOutlined />
        </IconButton>
      </Tooltip>
    </>
  );
};
